<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'partner-create'}">Neuen Partner erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Partner</h1>
            <table class="table table-striped" v-if="partners !== false">
                <thead>
                <tr>
                    <th>Title</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(partner, index) in partners">
                    <td>{{partner.name.text}}</td>
                    <td class="text-right">
                        <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, partner),
                            message: 'Bist du sicher, dass du den Partner <strong>'+partner.name.text+'</strong> löschen möchtest?'}"><i
                                class="fa fa-trash fa-fw"></i></a>
                        <router-link :to="{name: 'partner-edit', params: {partnerId: partner.id}}"><i class="fa fa-edit fa-fw"></i>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    partners() {
      return axios
        .get("/api/" + store.state.language + "/partner/list")
        .then(({ data }) => {
          return data.result;
        });
    }
  },
  methods: {
    remove(dialog, partner) {
      this.partners.splice(this.partners.indexOf(partner), 1);
      axios.post("/api/" + store.state.language + "/partner/" + partner.id + "/delete");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/partner/List.vue